var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundlessSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5726 21.2223C26.5726 22.6444 25.996 23.9306 25.0624 24.8621C24.1317 25.7906 22.849 26.3636 21.4313 26.3636C18.5918 26.3636 16.2899 24.0618 16.2899 21.2223C16.2899 18.3828 18.5918 16.0809 21.4313 16.0809C24.2707 16.0809 26.5726 18.3828 26.5726 21.2223Z",
    stroke: "white",
    strokeOpacity: 0.56,
    strokeWidth: 1.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7986 29.4645C29.0407 29.7066 29.4333 29.7066 29.6754 29.4645C29.9175 29.2223 29.9175 28.8298 29.6754 28.5876L28.7986 29.4645ZM25.0616 25.7275L28.7986 29.4645L29.6754 28.5876L25.9384 24.8507L25.0616 25.7275Z",
    fill: "white",
    fillOpacity: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundlessSearchIcon);
export default __webpack_public_path__ + "static/media/backgroundless-search-icon.f02b41904d7fa4f657b0dcc071952db7.svg";
export { ForwardRef as ReactComponent };